import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getDevolutionByUser } from '../../../actions/inventoryActions'
import DevolutionByUserView from '../../../containers/Inventory/Devolutions/DevolutionByUser'

const DevolutionByUser = () => {
    const dispatch = useDispatch()
    const {userInfo} =  useSelector(state =>state.userInfo)
    const {devolutions} =  useSelector(state =>state.inventory)
    useEffect(() => {
      if(userInfo._id){
        let id = userInfo._id;
        if (userInfo.representativeID) {
          if (userInfo.representativeID.state ===2) {
            id = userInfo.representativeID._id
          }
        }
        if (userInfo.franchiseID) {
          if (userInfo.franchiseID.state ===2) {
            id = userInfo.franchiseID._id
          }
        }
        if (userInfo.warehouseID) {
          id = userInfo.warehouseID
    
        }
        if(id.length>0){
            dispatch(getDevolutionByUser(id))
        }
      }
       
       
      
    
      return () => {
        
      }
    }, [userInfo])
    
  return (
    <DevolutionByUserView devolutions ={devolutions} />
  )
}

export default DevolutionByUser